import { render } from "./CongratulationsScreen.vue?vue&type=template&id=5d6a2a31&scoped=true"
import script from "./CongratulationsScreen.vue?vue&type=script&lang=js"
export * from "./CongratulationsScreen.vue?vue&type=script&lang=js"

import "./CongratulationsScreen.vue?vue&type=style&index=0&id=5d6a2a31&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d6a2a31"]])

export default __exports__